import React from 'react';

/**
 * Session header component that displays additional exam session information
 * @param {Object} props Component props
 * @param {Object} props.sessionSetup Session setup data
 * @param {Object} props.themeStyles Theme styles object
 * @param {boolean} props.isDarkMode Dark mode state
 */
const SessionHeader = ({
  sessionSetup,
  themeStyles,
  isDarkMode
}) => (  <div style={{
    backgroundColor: isDarkMode ? 'rgba(30, 41, 59, 0.8)' : 'rgba(241, 245, 249, 0.9)', 
    padding: '10px 18px', // Reduced from 14px to 10px vertical padding
    borderRadius: '10px',
    marginBottom: '12px', // Reduced from 20px to 12px
    boxShadow: isDarkMode ? '0 2px 8px rgba(0, 0, 0, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.04)',
    border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease'
  }}>
    {(sessionSetup?.systems || sessionSetup?.disciplines) && (
      <div style={{
        display: 'flex',
        gap: '15px',
        fontSize: '13px',
        color: isDarkMode ? '#94a3b8' : '#64748b',
        fontWeight: 500,
        opacity: 0.9
      }}>
        {sessionSetup?.systems && <span>{Array.isArray(sessionSetup.systems) ? sessionSetup.systems.join(', ') : sessionSetup.systems}</span>}
        {sessionSetup?.systems && sessionSetup?.disciplines && <span>|</span>}
        {sessionSetup?.disciplines && <span>{Array.isArray(sessionSetup.disciplines) ? sessionSetup.disciplines.join(', ') : sessionSetup.disciplines}</span>}
      </div>
    )}
  </div>
);

export default SessionHeader;
